module.exports = __webpack_public_path__ + "static/media/assignment_return-1.f67fd410.svg";